/** @format */

import { createAction, createReducer } from '@reduxjs/toolkit';

const initialState = {
  impostazioni: {},
  session: null,
  user: {
    username: 'UtenteTest',
    role: 'administrator',
    idNumber: '1HF73'
  },
  history: []
};
export const addToHistory = createAction('addToHistory');
export const updateImpostazioni = createAction('updateImpostazioni');

const reducer = createReducer(initialState, (builder) => {
  builder
    .addCase(addToHistory, (state, action) => {
      // action is inferred correctly here
      state.history = [...state.history, action.payload];
    })
    .addCase(updateImpostazioni, (state, action) => {
      state.impostazioni = { ...state.impostazioni, ...action.payload };
    });
});

export default reducer;
